import { authHeader } from '../_helpers';

export const loginService = {
    login,
    logout,
    RestablecerPwd
};

function login(pAcceso) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(pAcceso)
    };
    return fetch(`${process.env.REACT_APP_URL_API}login/iniciarsesion`, requestOptions)
        .then(handleResponse)
        .then(info => {
            if (info.exito) {
                localStorage.setItem('user', JSON.stringify(info.docs));
            }

            return info;
        });
}
//Falta
function RestablecerPwd(correo) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${process.env.REACT_APP_URL_API}usuario/restablecer/${correo}`, requestOptions).then(handleResponse);
}

function logout() {
    localStorage.removeItem('user');
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                window.location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return (error);
        }

        return data;
    });
}